module.exports = __webpack_public_path__ + "static/media/niubiz-logo.d1943c4b.webp";